import { Component, ViewModel, View } from "binder";
import { getAsBoolean } from "../utilities";
import { FileSelectorView } from "./fileSelector-view"
import { translate } from "src/common/utilities";

export class FileSelectorViewModel extends Component {
    constructor(parentViewModel: ViewModel, maxSize?: number) {
        super(parentViewModel);
        this.maxsize = maxSize ?? 0;
    }
    GetDefaultView(): View<ViewModel> {
        return new FileSelectorView();
    }
    public getTypeId(): string {
        return "VM-5B78310C-CFE6-4C5E-92AA-81EE47D79F79"
    }

    public set filename(v: string) { this._filename = v; } public get filename(): string { return this._filename; } private _filename: string;
    public set fileid(v: string) { this._fileid = v; this.checkDownloadability(); } public get fileid(): string { return this._fileid; } private _fileid: string;
    public set filecontent(v: string) { this._filecontent = v; this.checkDownloadability(); } public get filecontent(): string { return this._filecontent; } private _filecontent: string;
    public set isreadonly(v: boolean) { this._isreadonly = getAsBoolean(v); } public get isreadonly(): boolean { return this._isreadonly; } private _isreadonly: boolean;
    public set downloader(v: IFileDownloader) { this._downloader = v; } public get downloader(): IFileDownloader { return this._downloader; } private _downloader: IFileDownloader;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading; } private _isLoading: boolean;
    public set candownload(v: boolean) { this._candownload = getAsBoolean(v); } public get candownload(): boolean { return this._candownload; } private _candownload: boolean;
    public set maxsize(v: number) { this._maxsize = v; } public get maxsize(): number { return this._maxsize; } private _maxsize: number;
    isFileChoosed(): boolean {
        if (this.fileid != null && this.fileid.trim() != '')
            return true;
        else if (this.filecontent != null && this.filecontent.trim() != '')
            return true;
        else
            return false;
    }
    checkDownloadability() {
        if (this.fileid != null && this.fileid.trim() != '')
            this.candownload = true;
        else if (this.filecontent != null && this.filecontent.trim() != '')
            this.candownload = true;
        else
            this.candownload = false;
    }
    chooseFile() {
        let input = document.createElement('input');
        input.type = 'file';
        input.onchange = e => {
            let file = (<any>e).target.files[0];
            this.filename = file.name;
            let size = file.size;
            if (this.maxsize && this.maxsize > 0 && size > this.maxsize * 1024) {
                let txt = translate("fileSelector-viewModel.maxFileSizeError", { size: this.maxsize });
                this.messageBoxConfirmWarning(txt, translate("fileSelector-viewModel.fileSizeLimit", {}));
                this.filename = "";
                return;
            }

            let reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onabort = x => {
                document.removeChild(input);
            }
            reader.onerror = x => {
                document.removeChild(input);
            }
            reader.onload = readerEvent => {
                let content = (<any>readerEvent.target.result).split(',')[1];
                this.filecontent = content;
                this.onFileChoosed(content);
                document.removeChild(input);
            }
        }
        input.click();

    }
    private b64toBlob(b64Data, contentType = '', sliceSize = 512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
    async getContent(): Promise<string> {
        if (this.requireFetch())
            await this.fetch();
        return this.filecontent;
    }
    async download() {
        if (this.requireFetch())
            await this.fetch();
        this.createDownloadLinkAndDownload();
    }

    onFileChoosed(content: string) {

    }

    createDownloadLinkAndDownload() {
        const blob = this.b64toBlob(this.filecontent); //new Blob([this.fileContent]);
        let nav = <any>navigator;
        if (nav.msSaveBlob) { // IE 10+
            nav.msSaveBlob(blob, this.filename);
        } else {
            const link = document.createElement('a');
            if (link.download !== undefined) {
                const url = URL.createObjectURL(blob);
                link.setAttribute('href', url);
                link.setAttribute('download', this.filename);
                link.style.visibility = 'hidden';
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
        }
    }
    requireFetch(): boolean {
        if (this.filecontent == null || this.filecontent.trim() == '')
            return true;
        return false;
    }
    async fetch() {
        try {
            this.isLoading = true;
            let result = await this.downloader.download(this.fileid, this.filename);
            this.filecontent = result.content;
            this.filename = result.name;
        }
        catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
}

export interface IFileDownloader {
    download(fileId: string, filename: string): Promise<{
        name: string,
        content: string
    }>;
}
